

































































import { saveFile } from "@/shared/saveFile";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";

export type RawScanDescriptor = {
  id: number;
  reservationId: number;
  timestamp: string;
  color: string;
  raw: any;
  events: {
    id: number;
    timestamp: string;
    name: string;
  }[];
};

@Component
export default class ScannerDebug extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @Prop() data?: RawScanDescriptor[];

  get isDebug() {
    // import is for our convinience,
    // it shouldn't show on prod as not to confuse anyone
    return (
      location?.hostname === "localhost" ||
      location?.hostname === "pms.infranet.hr"
    );
  }

  copy() {
    this.copyTextToClipboard(JSON.stringify(this.data))
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "info",
          message: "Copied to clipboard.",
          timeout: 1000,
        });
      })
      .catch((message) => {
        this.$store.dispatch("showNotification", {
          color: "error",
          message,
          timeout: 30000,
        });
      });
  }

  downloadJson() {
    const stringy = JSON.stringify(this.data)?.toString();
    const blob = new Blob([stringy], { type: "text/json" });

    saveFile(blob, "debug.json");
  }

  paste() {
    this.getTextFromClipboard()
      .then((data) => {
        this.$emit("pasted", data);
        this.$store.dispatch("showNotification", {
          color: "info",
          message: "Imported from clipboard.",
          timeout: 1000,
        });
      })
      .catch((message) => {
        this.$store.dispatch("showNotification", {
          color: "error",
          message,
          timeout: 30000,
        });
      });
  }

  fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      return Promise.resolve("copy_success");
    } catch (err) {
      return Promise.reject(err);
    } finally {
      document.body.removeChild(textArea);
    }
  }

  async copyTextToClipboard(text: string) {
    if (!navigator.clipboard) {
      await this.fallbackCopyTextToClipboard(text);
      return;
    }
    await navigator.clipboard.writeText(text);
  }

  async getTextFromClipboard() {
    // this is for us, developers, so no fallbacks
    // nobody runs an outdated browser i hope
    const stringy = await navigator.clipboard.readText();
    return JSON.parse(stringy);
  }
}
